export const NotificationConstants = {
  GETNOTIFICATION_REQUEST: "NOTIFICATION_GETALL_REQUEST",
  GETNOTIFICATION_SUCCESS: "NOTIFICATION_GETALL_SUCCESS",
  GETNOTIFICATION_FAILURE: "NOTIFICATION_GETALL_FAILURE",

  GETUNREAD_NOTIFICATION_REQUEST: "UNREAD_NOTIFICATION_REQUEST",
  GETUNREAD_NOTIFICATION_SUCCESS: "UNREAD_NOTIFICATION_SUCCESS",
  GETUNREAD_NOTIFICATION_FAILURE: "UNREAD_NOTIFICATION_FAILURE",

  READ_NOTIFICATION_REQUEST: "READ_NOTIFICATION_REQUEST",
  READ_NOTIFICATION_SUCCESS: "READ_NOTIFICATION_SUCCESS",
  READ_NOTIFICATION_FAILURE: "READ_NOTIFICATION_FAILURE",

  GETNOTIFICATION_STATUS_REQUEST: "NOTIFICATION_STATUS_GETALL_REQUEST",
  GETNOTIFICATION_STATUS_SUCCESS: "NOTIFICATION_STATUS_GETALL_SUCCESS",
  GETNOTIFICATION_STATUS_FAILURE: "NOTIFICATION_STATUS_GETALL_FAILURE",
};
